/* Ana sayfa slayt bannerlarında "hafif dokunuş = bağlantıya git" (31 Eki 2026).
   Swiper (solma efekti + döngü) dokunmatik ekranda, slayt üstündeki tam kaplayan bağlantının "click" olayını üst kaba (swiper-wrapper) düşürüyor;
   bu yüzden bağlantı yalnızca fare ile çalışıyordu. Burada parmak 10 px'ten az oynayıp 0,6 sn'den kısa dokunursa (kaydırma/uzun basma değil)
   o noktadaki .naar-slayt-baglanti adresine gidilir. Düğme/başka bağlantıya dokunulduysa karışılmaz. Kaydırma, oklar ve noktalar etkilenmez. */
(function () {
  if (window.naarSlaytDokunma) return;
  window.naarSlaytDokunma = true;
  var bas = null;
  document.addEventListener('touchstart', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (!t || e.touches.length > 1) { bas = null; return; }
    bas = { x: t.clientX, y: t.clientY, z: Date.now() };
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    var b = bas; bas = null;
    var t = e.changedTouches && e.changedTouches[0];
    if (!b || !t) return;
    if (Math.abs(t.clientX - b.x) > 10 || Math.abs(t.clientY - b.y) > 10 || Date.now() - b.z > 600) return;
    var hedef = document.elementFromPoint(t.clientX, t.clientY);
    var baglanti = hedef && hedef.closest ? hedef.closest('.naar-slayt-baglanti') : null;
    if (!baglanti || !baglanti.href) return;
    if (e.target && e.target.closest && e.target.closest('.swiper-button, .swiper-pagination, button, a:not(.naar-slayt-baglanti)')) return;
    e.preventDefault(); /* aynı dokunuşun ikinci (click) gezinmesini engeller */
    window.location.href = baglanti.href;
  }, { passive: false, capture: true });
})();
